import { atom, atomWithPolling } from '@exodus/headless-ui';
import configAtom from './config.js';
import exchangeErrorAtom from './exchange-error.js';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
import { computePollInterval } from '../helpers/poll-interval.js';
import swapModeAtom from './swap-mode.js';
import fromAmountAtom from './from-amount.js';
import toAmountAtom from './to-amount.js';
import fromWalletAccountAtom from './from-wallet-account.js';
import toWalletAccountAtom from './to-wallet-account.js';
import slippageAtom from './slippage.js';
import isSendAllAtom from './is-send-all.js';
const amountAtom = atom((get) => {
    const swapMode = get(swapModeAtom);
    const fromAmount = get(fromAmountAtom);
    const toAmount = get(toAmountAtom);
    return swapMode === 'ExactIn' ? fromAmount : toAmount;
});
const quoteRequestAtom = atom((get) => ({
    fromAssetName: get(fromAssetAtom).name,
    toAssetName: get(toAssetAtom).name,
    amount: get(amountAtom),
    fromWalletAccount: get(fromWalletAccountAtom).toString(),
    toWalletAccount: get(toWalletAccountAtom).toString(),
    slippage: get(slippageAtom),
    isSendAll: get(isSendAllAtom),
    swapMode: get(swapModeAtom),
}));
const buildQuoteKey = (request) => [
    request.fromAssetName,
    request.toAssetName,
    request.swapMode,
    request.amount.toBaseString(),
    request.slippage,
    request.isSendAll,
    request.fromWalletAccount,
    request.toWalletAccount,
].join('|');
const quoteSourceAtom = atomWithPolling(async (get, { exodus }) => {
    get(exchangeErrorAtom);
    const config = get(configAtom);
    const request = get(quoteRequestAtom);
    if (request.amount.isZero) {
        return {
            value: { ok: true, value: null },
            interval: config.defaultPollIntervalMs,
        };
    }
    try {
        const quote = await exodus.exchange.getBestQuote({
            ...request,
            swapMode: request.swapMode,
            expiryMarginMs: config.expiryMarginMs,
        });
        if (!quote) {
            return {
                value: { ok: true, value: null },
                interval: config.defaultPollIntervalMs,
            };
        }
        const interval = computePollInterval({
            expiry: quote.expiry,
            expiryMarginMs: config.expiryMarginMs,
            defaultPollIntervalMs: config.defaultPollIntervalMs,
            stalePollIntervalMs: config.stalePollIntervalMs,
        });
        return { value: { ok: true, value: quote }, interval };
    }
    catch (error) {
        return {
            value: { ok: false, error: error },
            interval: config.defaultPollIntervalMs,
        };
    }
});
const quoteAtom = atom(async (get) => {
    const result = await get(quoteSourceAtom);
    if (!result.ok)
        throw result.error;
    return result.value;
});
quoteAtom.cacheKey = (get) => buildQuoteKey(get(quoteRequestAtom));
export default quoteAtom;
